import { PriceFormatter } from '../../utilities';

export const toInt = (v: string | number) => (typeof v === 'string' ? parseInt(v, 10) : v);

export const centsToDollarsFormatter = (centsStr: number | string) =>
  centsStr ? PriceFormatter.format(toInt(centsStr) / 100) : '';

export const removeNonNumerics = (v: string) => v.replace(/\D/g, '');
